
import { green, red } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    content: {
        padding: theme.spacing(2),
        '&:first-child': {
            paddingTop: theme.spacing(2)
        }
    },
    icon: {
        display: 'flex',
        fontSize: theme.spacing(3),
        '& svg': {
            fontSize: '2em'
        }
    },
    paperWidthSm: {
        maxWidth: 300,
        height: 'unset',
        borderRadius: 4
    },
    container: {
        display: 'grid',
        justifyItems: 'center',
        alignContent: 'center',
        gap: theme.spacing(1),
        height: 150
    },
    success: {
        '& svg': {
            color: green[300]
        }
    },
    error: {
        '& svg': {
            color: red[300]
        }
    }
}));